export default __webpack_public_path__ + "d60001b3fb7291e2ef974ca0a039797c.svg";